import React from 'react';
import {useDispatch} from 'react-redux'
import {setCompanyId, setCompany} from './redux/reducers/app'
import {useSelector} from 'react-redux'

function addDefaultSrc(ev)  {
    ev.target.src = '/images/user.svg';
}

const Logo = (props) => {
  return (
          <h1>
              <a href="index.html">
                <img className="logo" src="/images/SAMI_logo_white.svg" alt="SAMI Bitumen Technologies Logo"/>
              </a>
          </h1>
  )
}

const Account = (props) => {
   let imageURL = props?.account?.companyLogoURL;
    
   let company;
   if(props?.account?.companyIds && props?.account?.companyIds.length > 1){
    company = <li>{props.isLoggedIn &&  <SelectCompany companies={props?.account?.companyIds}  /> }</li>;
   }else{
    company = <li className ="companyName">{props?.account?.companyName}</li>; 
   }
   
    return (
        <div className="account">
            <ul>
                <li>{props?.account?.userFullName}</li>
              
             {company}

             { props?.account?.userFullName ? <li><button className='logout' onClick={props.logout}>Logout</button></li>: null }
                 
            </ul>
            {imageURL && <img className="customer-logo" src={imageURL} onError={addDefaultSrc} alt="customer logo"/>}
           
        </div>
    )
}


const SelectCompany = ({ companies }) => {
  const defaultCompanyId = useSelector(state => state.app.companyId)
  const dispatch = useDispatch();

  return (
    <select className="companySelect" onChange={(event) => dispatch(setCompany(event.target.value))} defaultValue={defaultCompanyId} aria-label="Select Company">
        {companies && companies.map((company) => (
        <option key={company.id} value={company.id}>{company.name}</option>
      ))}
    </select>

  )
}

const Header = (props) => {
    const multipleCompanies = props?.account?.companyIds && props?.account?.companyIds?.length > 1;
    return (
      <header className={multipleCompanies ? "withCompanySelection" : ""}>
            <Logo/>
           
            <Account
                account={props.account}
                isLoggedIn={props.isLoggedIn}
                companyIds={props.account?.companyIds}
                logout={props.logout}
            />
        </header>
    )
  }

export default Header;
